module.exports = __webpack_public_path__ + "img/jasw.90faede7.png";